import React, { useState, useEffect } from 'react'
import { Row, Col, Card, Button, Modal, Form } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SpinLoader from '../../component/loader/SpinLoader';
import { pythonAxiosInstance } from '../../config/ConfigInfo';
import { getItem, setItem } from '../../config/localStorage';


function AffiliationsModal(props) {
    const jobTitle = getItem('jobTitle');
    const saveAffiliationEditorItem = getItem('affiliationsData');
    const checkAffilidationEditorList = saveAffiliationEditorItem ? saveAffiliationEditorItem.split('</p>') : '';

    const [affiliationsEditorItem, setAffiliationEditorItem] = useState(saveAffiliationEditorItem ? saveAffiliationEditorItem : '');
    const [affiliationList, setAffiliationList] = useState([]);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [affiliationValidation, setAffiliationValidation] = useState('');
    const [searchToggle, setSearchToggle] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [loader, setLoader] = useState(true);

    let saveAffiliationList;
    if (saveAffiliationEditorItem) {
        function removeHtmlTags(str) {
            return str.replace(/<\/?[^>]+(>|$)/g, "");
        }
        saveAffiliationList = checkAffilidationEditorList.filter(item => item.trim() !== "").map(removeHtmlTags);
    }

    /** call API to fetch the Affiliation data start */
    
    useEffect(() => {
        (async () => {
            const raw = {
                job_title: searchInput === '' ? jobTitle : searchInput
            };
            try {
                setLoader(true);
                const response = await pythonAxiosInstance.post('generate-affiliations-based-jobtitle/', raw);
                if (response.status === 200) {
                    let updatedAffiliation;
                    if (saveAffiliationList) {
                        updatedAffiliation = response.data.affiliations.map((list) => {
                            const match = saveAffiliationList.find((item) => item === list.name);
                            if (match) {
                                return { ...list, disabled: true };
                            }
                            return list;
                        });
                    } else {
                        updatedAffiliation = response.data.affiliations;
                    }

                    setLoader(false);
                    setAffiliationList(updatedAffiliation);
                    setError('');
                }
            } catch (error) {
                setError(error.message);
                setLoader(false);
            }
        })()
    }, [searchInput, searchToggle]);

    /** call API to fetch the Affiliation data end */

    /** search functionality start */

    const handleAffiliationSearch = (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setAffiliationValidation('');
        if (e.target.elements.searchAffiliation.value === '') {
            setError('Please enter a job title');
        } else {
            setSearchToggle(!searchToggle);
            setSearchInput(e.target.elements.searchAffiliation.value);
        }
    };

    /** search functionality end */

    const saveAffiliation = () => {
        setAffiliationValidation('');
        setSuccess('');
        setError('');
        if (affiliationsEditorItem === '') {
            setAffiliationValidation('Please enter the affiliation');
            // removeSetItem('affiliationsData');
        } else {
            setItem('affiliationsData', affiliationsEditorItem);
            setSuccess('Thank you for providing your affiliation details.');
        }
    }

    

    const handleAffiliationListClick = (itemName) => {
        const affiliationListCopy = [...affiliationList];
        const appendAffiliation = affiliationsEditorItem ? affiliationsEditorItem + '<p>' + itemName + '</p>' : '<p>' + itemName + '</p>';
        setAffiliationEditorItem(appendAffiliation);
        setAffiliationValidation('');
        affiliationListCopy.forEach(item => {
            if (affiliationsEditorItem.includes(item.name)) {
                item.disabled = true;
            }
        });
        setAffiliationList(affiliationListCopy);
        setSuccess('');
    }

    const handleEditorDataChange = (event, editor) => {
        const content = editor.getData();
        const strippedData = content.replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/&nbsp;/g, ' ');

        const matchSkillsList = affiliationList.map(dataItem =>
            strippedData.includes(dataItem.name) ? { ...dataItem, disabled: true } : { ...dataItem, disabled: false }
        );

        setAffiliationEditorItem(content);
        setAffiliationList(matchSkillsList);
        setSuccess('');
    }

    const affiliationsEditor = {
        ui: {
            poweredBy: {
                forceVisible: true
            }
        },
        toolbar: [
            'bold',
            'italic',
        ],
        toolarLocation: 'bottom',
        placeholder: 'Add your affiliation'
    };

    const closePopUp = () => {
        setSuccess('')
        setError('')
        setAffiliationValidation('')
    };

    return (
        <>
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop='static'
            >
                <Modal.Header closeButton onClick={closePopUp}>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Affiliations
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={6} className='mb-3'>
                            <Col md={12} className='skill-left-section'>
                                <h6 className='text-center mt-2'>Search By Job Title For Pre-Written Examples</h6>
                                <Col md={12} className='ai-search-skill-form'>
                                    <Form onSubmit={handleAffiliationSearch}>
                                        <div className='ai-serach-form-section'>
                                            <div className='input-section'>
                                                <Form.Control
                                                    placeholder="Search By Job Title"
                                                    size="lg"
                                                    type='text'
                                                    id="searchAffiliation"
                                                />
                                            </div>
                                            <div className='button-section'>
                                                <button type="submit" className="search-skill-btn"><i className="fa fa-search"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                    {
                                        error ?
                                            <Col md={12} className='mt-3 d-inline-block w-100'>
                                                <div className="alert alert-danger" role="alert">
                                                    {error}
                                                </div>
                                            </Col> : ''
                                    }
                                </Col>
                                <Col md={12} className='mt-3 ai-search-skill-result-part'>
                                    <Card>
                                        <Card.Body>
                                            <Card.Title>Ready-to-use-examples</Card.Title>
                                            <div className='ai-list-item'>
                                                <ul>
                                                    {
                                                        loader === true ? <SpinLoader /> :
                                                            affiliationList?.map((item, index) => (
                                                                <li key={item.id} item={item.name} >
                                                                    <div className='button-part'>
                                                                        <Button onClick={() => handleAffiliationListClick(item.name, index)} disabled={item.disabled}>
                                                                            <i className="fa fa-plus" aria-hidden="true"></i>
                                                                        </Button>
                                                                    </div>
                                                                    <div className='text-part source-editor-1'>
                                                                        <p>{item.name}</p>
                                                                    </div>
                                                                </li>
                                                            ))
                                                    }
                                                </ul>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Col>
                        </Col>
                        <Col md={6} className='mb-3'>
                            <Col md={12} className='skill-right-section responsive-right-section'>

                                <h4 className='mb-3 fw-bold'>What are your affiliations?</h4>
                                <div className='skill-right-content-part'>
                                    <div className='summary-editor '>
                                        <CKEditor
                                            editor={ClassicEditor}
                                            config={affiliationsEditor}
                                            data={affiliationsEditorItem}
                                            onChange={handleEditorDataChange}
                                        />
                                    </div>
                                </div>
                                {
                                    affiliationValidation ? <div className="alert alert-danger mt-3" role="alert">{affiliationValidation}</div> : ''
                                }
                                {
                                    success !== '' ? <div className="alert alert-success mt-3" role="alert">{success}</div> : ''
                                }

                            </Col>
                        </Col>
                        <Modal.Footer>
                            <Button className='button-green' type="submit" onClick={saveAffiliation}>Save changes</Button>
                        </Modal.Footer>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AffiliationsModal
